export function copy(val) {
    return JSON.parse(JSON.stringify(val))
}

export function transOperator(type) {
    let value
    switch (type) {
        case 'add': {
            value = '+'
            break
        }
        case 'multiply': {
            value = 'x'
            break
        }
        case 'minus': {
            value = '-'
            break
        }
        case 'divide': {
            value = '÷'
            break
        }
    }
    return value
}

export function EventHub() {
    //定义一个用来存储回调的对象
    let eventList = {}
    // 事件订阅
    EventHub.prototype.on = function (eventName, callback) {
        //拿到key的值
        let eventCallbacks = eventList[eventName]
        if (eventCallbacks) {
            // 判断是否有注册事件，如果条件成立，说明该事件已经注册过，所以我们可以把函数push进数组中
            eventCallbacks.push(callback)
        } else {
            // 如果没有注册事件以数组的形式存储一份  因为一个事件下面可以注册多个函数
            eventList[eventName] = [callback]
        }
    }
    //事件分发
    EventHub.prototype.emit = function (eventName, data) {
        // 还是拿到key 的值
        let callbacks = eventList[eventName]
        if (callbacks && callbacks.length > 0) {
            // 条件成立之后 通过遍历拿到每个存储的函数
            callbacks.forEach(callback => callback(data))
        }
    }
    // 事件移除
    EventHub.prototype.off = function (eventName) {
        // 如果传入值为空 移除所有监听事件
        if (typeof eventName === 'undefined') {
            eventList = {}
        } else {
            // 移除指定的监听事件
            delete eventList[eventName]
        }
    }
}

export function getAction(value) {
    if (value.constructor === Function) {
        return [value, {}]
    } else {
        return [value.action, value.params]
    }
}

// 常用校验正则
export const normalRegular = [
    {
        name: '手机号',
        pattern: '/^1(3|4|5|6|7|8|9)\\d{9}$/'
    },
    {
        name: '邮箱',
        pattern: '/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/'
    },
    {
        name: '身份证号',
        pattern: '/^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$/'
    },
    {
        name: '网址',
        pattern: '/^((https?|ftp|file):\\/\\/)?([\\da-z\\.-]+)\\.([a-z\\.]{2,6})([\\/\\w \\.-]*)*\\/?$/'
    },
    {
        name: ' IP地址',
        pattern: '/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/'
    },
    {
        name: '整数',
        pattern: '/^\\d+$/'
    },
    {
        name: '小数',
        pattern: '/^[0-9.]+$/'
    }
]
export const isValidRegex = str => {
    return /^\/\^.*\/$/.test(str)
}
// 导出的流Blob,filename导出的文件名
export function downloadFileBlob(data, filename, type = '.xlsx') {
    if (!data) {
        return
    }
    const url = window.URL.createObjectURL(new Blob([data]))
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', filename + type)

    document.body.appendChild(link)
    link.click()
}

export const isPersonalInfoInput = label => {
    return ['手机号', '邮箱', '身份证'].includes(label)
}